import { useEffect, useState } from "react";
import { Input, Select } from "antd";
import { debounce } from "lodash";
import { useDynamicFormStore } from "@stores/dynamicFormStore";

const PreSelectInputField = (props: any) => {
  const { value: initialValue, isEditable, placeholder, handleRulesOnValueChange, rule } = props;
  const [value, setValue] = useState(initialValue || "");
  const [validField, setValidField] = useState(true);
  const [selectedOption, setSelectedOption] = useState(rule[0]?.value || "");
  const [validationParams, setValidationParams] = useState(rule[0]?.textValidation || {});
  const [setIsInvalidFlag] = useDynamicFormStore((state) => [state.setIsInvalidFlag]);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const selectedRule = rule.find((option: any) => option.value === selectedOption);
    setValidationParams(selectedRule ? selectedRule.textValidation : {});
    validateField("");
  }, [selectedOption]);

  const handleValueChange = (inputValue: string) => {
    setValue(inputValue);
    handleRulesOnValueChange(inputValue);
    validateField(inputValue);
  };

  const validateField = debounce((inputValue: string) => {
    const { maxLength, fixedLength } = validationParams;
    const _maxLength = maxLength ? maxLength : fixedLength ? fixedLength : 100;

    let isValid = true;

    if (fixedLength) {
      isValid = inputValue.length === fixedLength;
    } else {
      isValid = inputValue.length <= _maxLength;
    }

    setValidField(isValid);
    setIsInvalidFlag(!isValid);
  }, 1000);

  const handleDropdownChange = (selected: any) => {
    setSelectedOption(selected);
    setValue("");
    validateField("");
  };

  const maxLength = validationParams.fixedLength || validationParams.maxLength || undefined;
  const validationMessage = `Please match the fixed length of ${validationParams.fixedLength} characters.`;

  const handleInputRules = (inputValue: string): string => {
    const inputType = validationParams.type;
    if (inputType === "number") {
      return inputValue.replace(/[^0-9]/g, "");
    } else if (inputType === "alphanumeric") {
      return inputValue.replace(/[^a-zA-Z0-9]/g, "");
    }
    return inputValue; 
  }

  return (
    <>
      <Input
        addonBefore={
          <Select value={selectedOption} onChange={handleDropdownChange} style={{ width: 150 }} disabled={!isEditable} size="large">
            {rule.map((opt: any) => (
              <Select.Option key={opt.value} value={opt.value}>
                {opt.value}
              </Select.Option>
            ))}
          </Select>
        }
        maxLength={maxLength}
        placeholder={placeholder}
        value={value}
        disabled={!isEditable}
        onChange={(e) => {
          const rawInput = e.target.value;
          const filteredInput = handleInputRules(rawInput);

          if ((validationParams.fixedLength && filteredInput.length <= validationParams.fixedLength) || (!validationParams.fixedLength && filteredInput.length <= validationParams.maxLength)) {
            handleValueChange(filteredInput);
          }
        }}
        className={`${props.className}__input__preselector`}
        size="large"
        prefix={validationParams.prefix || ""}
        suffix={validationParams.postfix || ""}
      />

      {!validField && validationParams.fixedLength && value && <h5 className="clr-e100">{validationMessage}</h5>}
    </>
  );
};

export default PreSelectInputField;